import { Component, Input, OnInit, OnChanges, SimpleChanges, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { PAP } from '../pap-dto/pap-dto';
import { Union } from 'src/app/models/Union';
import { Poll } from 'src/app/models/Poll';
import { CollegeCandidatesData } from './poll-creation-union/poll-creation-union.component';

@Component({
  selector: 'app-cse-poll-creation',
  templateUrl: 'cse-poll-creation.component.html',
  styleUrls: ['./cse-poll-creation.component.less', '../../shared/common.less'],
})

export class CsePollCreationComponent implements OnInit, OnChanges {
  @ViewChild('scrollContainer') scrollContainer: ElementRef;
  @Input() step: number = 1;
  @Input() papValues: PAP;
  @Input() poll: Poll;
  @Input() unions: Array<Union> = [];
  @Input() votersConfirmed: boolean = false;
  @Input() areAssessorsValidated: boolean = false;
  @Output() unionsChange = new EventEmitter<Array<Union>>();

  @Output() papValuesChange = new EventEmitter<PAP>();
  @Output() papPollChange = new EventEmitter<Poll>();
  @Output() toPapVerification = new EventEmitter();
  @Output() toCerfaVerification = new EventEmitter();
  @Output() toCerfaCreation = new EventEmitter();
  @Output() toPollCreation = new EventEmitter();
  @Output() numberOfCollegesChanges = new EventEmitter<number>();
  @Output() confirmVoters = new EventEmitter<void>();
  @Output() onUnionImageChange = new EventEmitter<Array<any>>();
  @Output() onElectionImageChange = new EventEmitter<{ imageBlob: Blob, extensionImage: string }>();
  @Output() assessorsValidated = new EventEmitter<void>();
  @Input() collegeCandidatesData: Array<CollegeCandidatesData> = [];
  @Output() collegeCandidatesDataChange = new EventEmitter<Array<CollegeCandidatesData>>();
  @Input() validatedColleges: Set<number> = new Set();
  @Output() validatedCollegesChange = new EventEmitter<Set<number>>();

  areUnionsValidated: boolean = false;

  backToPapVerification() {
    this.toPapVerification.emit();
  }

  toStepFour() {
    this.confirmVoters.emit();
  }

  onSendPollImage(event: Array<any>) {
    this.onUnionImageChange.emit(event);
  }

  handleElectionImageChange(event: { imageBlob: Blob, extensionImage: string }) {
    this.onElectionImageChange.emit(event);
  }

  onAssessorsValidated() {
    this.assessorsValidated.emit();
  }

  onCollegeCandidatesDataChange(event: Array<CollegeCandidatesData>) {
    this.collegeCandidatesData = event;
    this.collegeCandidatesDataChange.emit(event);
  }

  onValidatedCollegesChange(event: Set<number>) {
    this.validatedColleges = event;
    this.validatedCollegesChange.emit(event);
  }

  onHeadcountChange(newHeadcount: any) {
    this.papValues.headcount = { ...newHeadcount };
    this.papValuesChange.emit(this.papValues);
  }

  onNumberOfCollegesChanges() {
    this.numberOfCollegesChanges.emit(this.papValues.headcount.numberOfColleges);
  }

  onPapValuesChange() {
    this.papValuesChange.emit(this.papValues);
  }

  onPollChanges() {
    this.papPollChange.emit(this.poll);
  }

  onUnionsChange(newUnions: Array<Union>) {
    this.unions = newUnions;
    this.unionsChange.emit(newUnions);
  }

  backToCerfaVerification() {
    this.toCerfaVerification.emit();
  }
  goToCerfaCreation() {
    this.toCerfaCreation.emit();
  }

  goToPollCreation() {
    this.toPollCreation.emit();
  }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['step'] && !changes['step'].firstChange) {
      if (this.scrollContainer && this.scrollContainer.nativeElement) {
        this.scrollContainer.nativeElement.scrollTo({ top: 0, behavior: 'smooth' });
      }
    }
  }
}
